// Список шрифтов для встраивания на сайте клиента
const fonts: string[] = [
  'Inter:wght@100;200;300;400;500;600;700;800;900&display=swap',
  'Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap',
  'PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  'PT+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  'Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
  'Roboto+Slab:wght@100;200;300;400;500;600;700;800;900&display=swap',
  'Roboto+Condensed:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap',
  'Oswald:wght@200;300;400;500;600;700&display=swap',
  'Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap',
  'Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap',
  'Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
  'Exo+2:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
  'Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
  'Pacifico&display=swap',
  'Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
  'Fira+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
  'Philosopher:ital,wght@0,400;0,700;1,400;1,700&display=swap',
  'Neucha&display=swap',
  'Yeseva+One&display=swap',
];

// Функция встраивания шрифтов на сайте клиента
const embeddingFonts = (): void => {
  const head = document.querySelector('head');

  fonts.forEach((font) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `https://fonts.googleapis.com/css2?family=${font}`;
    link.media = 'all';

    head.appendChild(link);
  });
};

export const initEmbeddingFonts = (): void => {
  embeddingFonts();
};
